"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _useRecommendationStepper = require("../../hooks/recommendation/useRecommendationStepper");
var _useLocalTheme = _interopRequireDefault(require("../../hooks/useLocalTheme"));
var _coreVerticalStepper = require("@vfuk/core-vertical-stepper");
var _useConfig = _interopRequireDefault(require("../../hooks/useConfig"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const StepperContainer = _styledComponents.default.div`
  #recommendationVerticalStepper {
    & h2 {
      color: ${prop => prop.colorTheme === 'light' ? '#ffff' : '#0D0D0D'};
    }
  }
`;
const RecommendationStepper = () => {
  const {
    steps,
    currentStep
  } = (0, _useRecommendationStepper.useRecommendationStepper)();
  const showRecommendationStepper = (0, _useLocalTheme.default)('showRecommendationStepper', true);
  const stepperSettings = (0, _useConfig.default)('uiSettings.stepper', {});
  steps[steps.length - 1].isFinal = stepperSettings === null || stepperSettings === void 0 ? void 0 : stepperSettings.showVerticalStepper;
  if (!showRecommendationStepper) return null;
  const stepperContent = (0, _react.useMemo)(() => stepperSettings !== null && stepperSettings !== void 0 && stepperSettings.showVerticalStepper ? /*#__PURE__*/_react.default.createElement(_coreVerticalStepper.VerticalStepper, {
    steps: steps,
    currentStep: currentStep,
    id: "recommendationVerticalStepper"
  }) : /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.HorizontalStepper, {
    steps: steps,
    currentStep: currentStep,
    id: "recommendationHorizontalStepper"
  }), [steps, currentStep]);
  return (steps === null || steps === void 0 ? void 0 : steps.length) === 1 ? null : /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 4,
      bottom: 4
    }
  }, /*#__PURE__*/_react.default.createElement(StepperContainer, {
    "data-testid": "recommendation-stepper",
    colorTheme: stepperSettings === null || stepperSettings === void 0 ? void 0 : stepperSettings.fontColor
  }, stepperContent));
};
var _default = RecommendationStepper;
exports.default = _default;